import type { NodeEntry } from 'slate';

import { renderContentBlockFns } from './content-block';
import { renderHeaderFooterFns } from './header-footer';
import type { RenderModelPage } from '../../slate-api';
import type { RenderContext } from '../engine/render-context';
import type { BaseRenderNodeOptions } from '../engine/rendering-data';

export function renderPage(
  renderContext: RenderContext,
  rMPageEntry: NodeEntry<RenderModelPage>,
  options: BaseRenderNodeOptions
) {
  renderContext.renderChildren(
    rMPageEntry,
    { ...renderHeaderFooterFns, ...renderContentBlockFns },
    options
  );
}
